import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export function initGalleries() {
  const elements = document.querySelectorAll(".js-swiper");
  elements.forEach((el) => {
    const swiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      pagination: {
        el: el.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector(".swiper-button-next"),
        prevEl: el.querySelector(".swiper-button-prev"),
      },
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true,
      },
    });
    return swiper;
  });
}

document.addEventListener("DOMContentLoaded", initGalleries);
